import React from 'react';
import styled from 'styled-components';
import { GapView } from '../styles/WrapperStyles';
import {
    InputText,
    ProfileInputText,
    ProfileInputView,
} from '../styles/TextStyles';

const ParentView = styled.div`
  width: 243px;
  margin-right: 20px;
  margin-top: 20px;
`;

const TextWrapper = styled.div`
  height: 72px;
  width: 243px;
  border-radius: 13px;
  border: solid 1px #d7d7d7;
  display: flex;
  justify-content: left;
  align-items: center;
  cursor: pointer;
`;

const InputStyle = styled(InputText)`
  width: 220px;
  color: #484848;
`;

export default function ProfileTextViewContainer(props) {
    return (
        <ParentView>
            <ProfileInputView>{props.title}</ProfileInputView>
            {props.input ? (
                <InputStyle
                    className={props.editable ? 'enableEdit' : 'disableEdit'}

                    type={props.type ? props.type : 'text'}
                    value={props.value}
                    onChange={(e) => props.setInputItem(props.title, e.target.value)}
                    disabled={!props.editable}
                />
            ) : (
                <TextWrapper
                    className={props.editable ? 'enableEdit' : 'disableEdit'}
                    onClick={() => {
                        if (props.editable) {
                            props.itemClicked(props.title)
                        }
                    }}
                >
                    <GapView width="20px" />{' '}
                    <ProfileInputText>{props.value}</ProfileInputText>
                </TextWrapper>
            )}
        </ParentView>
    );
}
